import { render, staticRenderFns } from "./InstructionText.vue?vue&type=template&id=378d24aa&"
import script from "./InstructionText.vue?vue&type=script&lang=js&"
export * from "./InstructionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports